import { createAction } from 'src/lib/createAction';

export const settingsActions = {
  setProductsPreference: createAction('settings/setProductsPreference')<
    'used' | 'new'
  >(),
} as const;
